<template>
  <h2 class="text-2xl font-bold text-blue">Please enter your details:</h2>

  <div class="flex flex-col gap-4">
    <div
      class="flex flex-col items-stretch justify-between gap-4 sm:flex-row sm:gap-2"
    >
      <label class="w-full">
        First Name
        <InputText
          name="firstName"
          placeholder="First name"
          :value="firstName"
          :error="errors.hasOwnProperty('formFields.firstName')"
          :error-message="getErrorMessage(errors, 'formFields.firstName')"
          @change="
            (event) =>
              $emit('changeParameter', {
                key: 'firstName',
                value: event.target.value,
              })
          "
        />
      </label>
      <label class="w-full">
        Last Name
        <InputText
          name="surname"
          placeholder="Last name"
          :value="surname"
          :error="errors.hasOwnProperty('formFields.surname')"
          :error-message="getErrorMessage(errors, 'formFields.surname')"
          @change="
            (event) =>
              $emit('changeParameter', {
                key: 'surname',
                value: event.target.value,
              })
          "
        />
      </label>
    </div>
    <label>
      Current Job Role
      <InputText
        name="jobTitle"
        placeholder="Current job role"
        :value="jobTitle"
        :error="errors.hasOwnProperty('formFields.jobTitle')"
        :error-message="getErrorMessage(errors, 'formFields.jobTitle')"
        @change="
          (event) =>
            $emit('changeParameter', {
              key: 'jobTitle',
              value: event.target.value,
            })
        "
      />
    </label>
    <label>
      Email Address
      <InputText
        name="emailAddress"
        placeholder="Email address"
        :value="emailAddress"
        :error="errors.hasOwnProperty('formFields.emailAddress')"
        :error-message="getErrorMessage(errors, 'formFields.emailAddress')"
        @change="
          (event) =>
            $emit('changeParameter', {
              key: 'emailAddress',
              value: event.target.value,
            })
        "
      />
    </label>
    <label>
      Phone Number
      <InputText
        name="telephoneNumber"
        placeholder="Your phone number"
        :value="telephoneNumber"
        :error="errors.hasOwnProperty('formFields.telephoneNumber')"
        :error-message="getErrorMessage(errors, 'formFields.telephoneNumber')"
        @change="
          (event) =>
            $emit('changeParameter', {
              key: 'telephoneNumber',
              value: event.target.value,
            })
        "
      />
    </label>
    <p>
      In order for us to offer you this service, the data you have entered will
      be shared with only this and any subsequent agencies that you visit.
      Please refer to our
      <static-search-link
        :to="{ name: 'privacyPolicy' }"
        class="cursor-pointer text-blue-30"
        >Privacy Policy</static-search-link
      >
      for further details.
    </p>
    <div class="rounded border border-grey-30 p-4">
      <label>
        <input
          type="checkbox"
          name="sharingConsent"
          :checked="sharingConsent"
          @change.prevent="
            () =>
              this.$emit('changeParameter', {
                key: 'sharingConsent',
                value: !sharingConsent,
              })
          "
        />
        I consent to Agency Central sharing my data in this way.
      </label>
    </div>
    <InputButton v-if="sharingConsent" style-type="contact-form" block @click="$emit('submitForm')">
        <template v-if="contactFormType == 'telfax'">
            Display Telephone Number
        </template>
        <template v-else>
            Visit website 
        </template>
    </InputButton>
  </div>
</template>

<script>
import HorizontalSeparator from 'Components/HorizontalSeparator';
import { getErrorMessage } from 'Helpers/helpers';
import InputText from 'Components/InputText';
import InputButton from 'Components/InputButton';
import StaticSearchLink from './StaticSearchLink.vue';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'ContactCandidateDetailsForm',
  components: {
    InputButton,
    InputText,
    HorizontalSeparator,
    StaticSearchLink,
  },
  props: {
    errors: {
      type: Object,
      default() {
        return {};
      },
    },
    firstName: {
      type: String,
    },
    surname: {
      type: String,
    },
    jobTitle: {
      type: String,
    },
    emailAddress: {
      type: String,
    },
    telephoneNumber: {
      type: String,
    },
    sharingConsent: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters('contact', ['contactFormType'])
  },
  methods: {
    ...mapActions('contact', ['loadPersistentInformation']),
    getErrorMessage,
  },
  mounted() {
    this.loadPersistentInformation();
  }
};
</script>
